import React from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import { useChatPlayDataContext } from '@provider/ChatPlayDataProvider';
import Draggable from 'react-draggable';

const DevTools = () => {
  const { chatPlayData, blockNameHistoryRef } = useChatPlayDataContext();
  const [isFold, setIsFold] = React.useState<boolean>(true);

  const onFold = () => {
    setIsFold((prev) => !prev);
  };

  return (
    <Draggable>
      <div css={devContainer}>
        <div className="fold">
          PlayInfo
          <div className="button" onClick={onFold}>
            {isFold ? '⬆️' : '⬇️'}
          </div>
        </div>
        {isFold && (
          <>
            <div className="title">속성</div>
            <div className="info-container">
              {chatPlayData?.props &&
                Object.keys(chatPlayData.props).map((item) => {
                  return (
                    <div className="item" key={item}>
                      {`${item} : `}
                      <div className="value">
                        {chatPlayData.props[item] ?? '--'}
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="divider"></div>
            <div className="title">아이템</div>
            <div className="info-container">
              {chatPlayData?.items &&
                Object.keys(chatPlayData.items).map((item) => {
                  return (
                    <div className="item" key={item}>
                      {item} :{' '}
                      <div className="value">
                        {chatPlayData.items[item] ?? '--'}
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="divider"></div>
            <div className="title">업적</div>
            <div className="info-container">
              {chatPlayData?.achievements &&
                Object.keys(chatPlayData.achievements).map((achievement) => {
                  return (
                    <div className="item" key={achievement}>
                      {achievement} :{' '}
                      <div className="value">
                        {chatPlayData.achievements?.[achievement] ?? '--'}
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="divider"></div>
            <div className="title">block</div>
            <div className="info-container">
              {blockNameHistoryRef?.current &&
                blockNameHistoryRef.current.map((item) => (
                  <div className="item" key={item.name}>
                    {item.name}
                  </div>
                ))}
            </div>
          </>
        )}
      </div>
    </Draggable>
  );
};

const devContainer = css`
  position: absolute;
  left: 0;
  width: 200px;
  background-color: white;
  max-height: 95vh;
  overflow-y: scroll;
  z-index: 100;
  border-radius: 10px;

  .fold {
    height: 2rem;
    background-color: ${theme.colors.gray400};
    display: flex;
    align-items: center;
    justify-content: space-around;
    .button {
      width: 2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .tool {
    font-size: 1.2em;
    font-weight: bold;
    padding: 0.5em;
    color: ${theme.colors.gray700};
    display: flex;
    justify-content: space-between;

    .icon {
      transform: rotate(-90deg);
    }
  }

  .info-container {
    max-height: 12rem;
    overflow-y: scroll;
  }

  .title {
    font-size: 1.2em;
    font-weight: bold;
    padding: 0.5em;
    color: ${theme.colors.gray700};
  }

  .item {
    width: 100px;
    font-size: 1em;
    font-weight: 400;
    margin: 0.3em;
    display: flex;
    margin-left: 1em;

    .value {
      margin-left: 0.3em;
      font-size: 1.1em;
      font-weight: 700;
      color: ${theme.colors.primary700};
    }
  }

  .divider {
    height: 1px;
    width: 100%;
    background-color: black;
  }

  @media screen and (max-width: ${theme.devices.mobile}) {
    display: none;
  }
`;

export default DevTools;
